import { render, staticRenderFns } from "./CitiesPieChart.vue?vue&type=template&id=457e4f85"
import script from "./CitiesPieChart.vue?vue&type=script&lang=js"
export * from "./CitiesPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('457e4f85')) {
      api.createRecord('457e4f85', component.options)
    } else {
      api.reload('457e4f85', component.options)
    }
    module.hot.accept("./CitiesPieChart.vue?vue&type=template&id=457e4f85", function () {
      api.rerender('457e4f85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Dashboard/Stats/CitiesPieChart.vue"
export default component.exports